import Vue from 'vue'
import { has, forEach, intersection, padStart, pick, isEqual, debounce } from 'lodash-es'

const _ = {
	has,
	forEach,
	intersection,
	padStart,
	pick,
	isEqual,
	debounce
}

Vue.prototype._ = _

window._ = _

export default _
